import styled from 'styled-components';
import { lighten } from 'polished';

import { Button } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { MdMenu as MenuIcon } from 'react-icons/md';

import { Input } from 'components/ui/Input';
import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';

export const StyledHeader = styled.header`
  z-index: 120;
  width: 100%;
  margin: auto;
  border-bottom: none;
  min-height: 65px;
  ${media.loginSmallMax`
    padding: 24px 12px;
  `};
  ${media.loginLargeMin`
    position: fixed;
    padding: 15px;
  `};
`;

export const StyledHeaderContainer = styled.div`
  float: right;
`;

export const StyledMenuIcon = styled(MenuIcon)`
  font-size: 30px;
  margin-right: 15px;
  color: ${colors.MENU_ITEM_GRAY};
`;

export const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${colors.LOGIN_BACKGROUND_GREY};
  background-image: url(${props => props.img || null});
  background-size: cover;
  position: fixed;
  overflow-y: scroll;
`;

export const StyledContainerOverlay = styled.div`
  height: 100%;
  width: 100%;
  background-image: ${props =>
    props.img && 'linear-gradient(76deg, rgba(19, 24, 40, 0) 0%, rgba(11, 12, 18, 0.7) 59%)'};
  background-size: cover;
  position: fixed;
  overflow-y: scroll;
`;

export const StyledRow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  ${media.loginSmallMax`
    flex-direction: column;
  `};
`;

export const StyledColumn = styled.div`
  position: relative;
  width: 50%;
  display: flex;
  flex: auto;
  justify-content: center;
  align-items: center;
  ${media.loginSmallMax`
    width: 100%;
  `};
`;

export const StyledCenterColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const StyledSSOButton = styled(Button)`
  margin-top: 20px;
  width: 100%;
  border-color: ${colors.OKTA_BLUE};
  color: ${colors.OKTA_BLUE};
  font-size: 18px;
  height: 50px;
  border-width: 2;
  text-transform: none;
`;

export const StyledCard = styled(Card)`
  color: ${colors.DARKEST_GRAY} !important;
  font-family: 'Circular' sans-serif !important;
  overflow: hidden;
  border-radius: 8px;
  padding: 15px;
  margin-top: 0;
  width: 550px;
  min-height: 400px;
`;

export const StyledCardContent = styled(CardContent)`
  padding: 0 0 10px;
  ${props => (!props.contentFullWidth ? 'margin: 0 8%' : null)};
`;

export const StyledLoginMessageH2 = styled.h2`
  padding: 0 0 10px;
  font-size: 36px;
  ${media.loginSmallMax`
    text-align: center;
  `};
  ${media.loginLargeMin`
    margin-top: 20px;
  `};
`;

export const StyledMobileContainer = styled.div`
  padding: 24px;
`;

export const StyledEmailLabelP = styled.p`
  margin: 0 0;
  font-size: 14px;
`;

export const StyledLabelP = styled.p`
  margin: 0 0;
  font-size: 16px;
`;

export const StyledLabelStrongP = styled.p`
  margin: 0 0;
  font-size: 16px;
  font-weight: 800;
`;

export const StyledPasswordLabelP = styled.p`
  margin: 1rem 0 0;
  font-size: 14px;
`;

export const StyledInput = styled(Input)`
  margin-top: 0.5rem;
  font-size: 16px;
  font-family: 'Circular';
  ::placeholder,
  ::-webkit-input-placeholder {
    font-size: 14px;
  }
  :-ms-input-placeholder {
    font-size: 14px;
  }
`;

export const StyledActionsContainer = styled.div`
  @media (max-width: 900px) {
    text-align: center;
    margin-top: 24px;
  }
  width: 100%;
  @media (min-width: 500px) and (max-width: 900px) {
    width: 350px;
  }
`;

export const StyledButton = styled.button`
  color: ${props => (props.disabled ? colors.BATTLESHIP_GREY : props.accentColor)};
  background-color: ${props =>
    props.disabled ? 'var(--pale-grey)' : lighten(0.55, props.accentColor)};
  line-height: normal;
  height: 48px;
  font-size: 20px;
  font-weight: 600;
  border: none;
  border-radius: 28px !important;
  padding: 1px 48px 0;
  text-align: center;
  cursor: pointer;
  font-family: 'Circular';
  ${media.loginSmallMax`
    width: 100%;
    margin: 24px 0 12px;
  `};
`;

export const StyledLinkButton = styled.button`
  font-family: 'Circular';
  font-size: ${props => (props.mobile ? '16px' : '20px')};
  font-weight: ${props => (props.mobile ? 'normal' : '600')};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: ${colors.ULTRAMARINE_BLUE};

  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0.5rem 0;
  padding: 0;
  border-radius: 0px !important;

  &:hover {
    text-decoration: none;
    color: #a3c2ff !important;
  }

  &:focus {
    text-decoration: none;
  }
`;

export const StyledATag = styled.a`
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;
  color: ${colors.ULTRAMARINE_BLUE};
  border-radius: 0px !important;
  font-size: 20px;
  font-weight: 600;

  &:hover {
    text-decoration: none;
    color: #a3c2ff !important;
  }

  &:focus {
    text-decoration: none;
  }
`;

export const StyledFullButton = styled.button`
  color: ${props => (props.disabled ? colors.BATTLESHIP_GREY : props.accentColor)};
  background-color: ${props =>
    props.disabled ? 'var(--pale-grey)' : lighten(0.55, props.accentColor)};
  line-height: normal;
  height: 48px;
  font-size: 18px;
  border: none;
  border-radius: 28px !important;
  padding: 1px 48px 0;
  text-align: center;
  cursor: pointer;
  font-family: 'Circular';
  width: 100%;
  margin-bottom: 12px;
`;

export const ButtonContainerStyled = styled.span`
  ${media.loginLargeMin`
    display: inline-block;
    margin: 30px 30px 0 0;
  `};
`;

export const LinkButtonContainerStyled = styled.span`
  ${media.loginLargeMin`
    display: inline-block;
    margin: 0 24px 24px 0;
  `};
`;

export const StyledInputContainer = styled.div`
  margin-top: 18px;
  text-align: left;
  font-family: 'Circular';
  width: 100%;
  @media (min-width: 500px) and (max-width: 900px) {
    width: 350px;
  }
`;
